@if (isAuthorized$ | async) {
  @if (consumptionEnabled$ | async) {
    <div class="ista-vertical-navigation-item py-1">
      <a class="text-sm font-normal" mat-button routerLinkActive="active" [routerLink]="['/user/consumption']">
        <mat-icon class="icon-size-6">monitoring</mat-icon>
        {{ "NAVIGATION_CONSUMPTIONS" | translate }}
      </a>
    </div>
  }

  @if (documentsEnabled$ | async) {
    <div class="ista-vertical-navigation-item py-1">
      <a class="text-sm font-normal" mat-button routerLinkActive="active" [routerLink]="['/user/document']">
        <mat-icon class="icon-size-6">description</mat-icon>
        {{ "NAVIGATION_DOCUMENTS" | translate }}
      </a>
    </div>
  }
} @else {
  <div class="ista-vertical-navigation-item py-1">
    <a class="text-sm font-normal" mat-button [routerLink]="['/welcome']">
      <mat-icon class="icon-size-6">home</mat-icon>
      {{ "HOME" | translate }}
    </a>
  </div>
}
